import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from './reportWebVitals';
import LayoutPage from './Components/LayoutPage';
import * as serviceWorker from './service-worker'; 
import { register } from './service-worker';
import * as serviceWorkerRegistration from './serviceWorkerRegistration'; // Import the registration file
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
const localBusinessJsonLd = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Alphai Solutions",
  "description": "Alphai Solutions is a tech company offering IT consulting, software development, and digital transformation services in Pakistan.",
  "url": "https://www.alphaisolutions.com/",
  "image": "https://www.alphaisolutions.com/logo.png",
  "logo": "https://www.alphaisolutions.com/logo.png",
  "telephone": "+92 333 5489960",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Block A Plaza# 1, Next to Askari Bank, Valencia Town, Commercial Market",
    "addressLocality": "Lahore",
    "addressRegion": "Punjab",
    "postalCode": "54000",
    "addressCountry": "PK"
  },
  "openingHours": [
    "Mo-Fr 09:00-18:00"
  ],
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "31.3949",
    "longitude": "74.2352"
  },
  "sameAs": [
    "https://www.facebook.com/alphaisolutions",
    "https://www.linkedin.com/company/alphai-solutions",
    "https://www.instagram.com/alphaisolutions"
  ],
  "review": [
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Ali Raza"
      },
      "datePublished": "2024-11-10",
      "reviewBody": "Excellent service and professional team. Highly recommended for software development projects.",
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": "5",
        "bestRating": "5"
      }
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Sarah Khan"
      },
      "datePublished": "2025-01-15",
      "reviewBody": "Great experience working with Alphai Solutions on our e-commerce platform. Delivered on time!",
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": "4.8",
        "bestRating": "5"
      }
    }
  ],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "reviewCount": "57"
  },
  "priceRange": "$$",
  "founder": {
    "@type": "Person",
    "name": "Your Name Here"
  },
  "foundingDate": "2020-01-10",
  "employee": {
    "@type": "OrganizationRole",
    "roleName": "Software Developer"
  },
  "areaServed": {
    "@type": "Country",
    "name": "Pakistan"
  },
  "makesOffer": [
    {
      "@type": "Offer",
      "itemOffered": {
        "@type": "Service",
        "name": "IT Consulting",
        "description": "Expert advice for digital transformation and technology planning."
      }
    },
    {
      "@type": "Offer",
      "itemOffered": {
        "@type": "Service",
        "name": "Web & App Development",
        "description": "Custom websites and mobile apps built for performance and scalability."
      }
    },
    {
      "@type": "Offer",
      "itemOffered": {
        "@type": "Service",
        "name": "UI/UX Design",
        "description": "Creating engaging and intuitive user experiences across platforms."
      }
    }
  ]
};


root.render(
  <div>
    <BrowserRouter>
    <script type="application/ld+json">
      {JSON.stringify(localBusinessJsonLd)}
    </script>
      <App />
    </BrowserRouter>
  </div>
);
serviceWorkerRegistration.register();

// register();
// serviceWorker.register();
reportWebVitals();
